<template>
  <v-container
    fluid
    style="
      margin-top: 0%;
      padding: 0% 0% 0 0;
      max-height: 100vh;
      overflow: hidden;
    "
  >
    <v-row style="margin: 0; padding: 0; position: relative">
      <v-col cols="12" class="pa-0">
        <GlobalNav />
      </v-col>
      <v-col
        cols="12"
        style="height: 100%"
        class="pa-0 d-flex align-start ga-6"
      >
        <SideBar />
        <div class="mt-6 msgbox">
          <BreadCrumb :linksData="linksData" class="mb-5" />
          <v-container fluid class="pa-0" style="height: 100vh">
            <v-row
              no-gutters
              class="w-100"
              style="
                border: 1px solid #eee;
                border-left: none;
                border-radius: 0 34px 0 0;
              "
            >
              <!-- Sidebar (Conversations List) -->
              <v-col
                cols="12"
                sm="4"
                class="pa-4 chatside"
                style="
                  border: 1px solid #eee;
                  overflow-y: hidden;
                  border-top: none;
                  border-bottom: none;
                  border-radius: 0 0px 34px 0;
                "
              >
                <!-- Title -->
                <div class="d-flex justify-space-between align-center">
                  <p class="w-100 text-h6 font-weight-bold">Messages</p>
                  <SelectAccId @account-selected="handleAccountSelected" />
                </div>

                <!-- Search Field -->
                <div class="d-flex align-center mb-2">
                  <v-menu
                    v-model="showFilterMenu"
                    :close-on-content-click="false"
                    offset-y
                  >
                    <v-card class="pa-2" style="min-width: 200px">
                      <v-row justify="center" class="mt-2">
                        <v-pagination
                          v-if="totalPages > 1"
                          v-model="currentPage"
                          :length="totalPages"
                          @update:modelValue="getConversations"
                          color="teal"
                          density="comfortable"
                        />
                      </v-row>
                    </v-card>
                  </v-menu>
                  <div class="my-2 w-100 search-conversation">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="20px"
                      viewBox="0 -960 960 960"
                      width="20px"
                      fill="#999999"
                    >
                      <path
                        d="M765-144 526-383q-30 22-65.79 34.5-35.79 12.5-76.18 12.5Q284-336 214-406t-70-170q0-100 70-170t170-70q100 0 170 70t70 170.03q0 40.39-12.5 76.18Q599-464 577-434l239 239-51 51ZM384-408q70 0 119-49t49-119q0-70-49-119t-119-49q-70 0-119 49t-49 119q0 70 49 119t119 49Z"
                      />
                    </svg>
                    <input
                      type="text"
                      placeholder="Search"
                      v-model="searchQuery"
                    />
                  </div>
                </div>
                
                <!-- مكان الـ pagination القديم داخل v-list -->
                <v-list
                  ref="conversationList"
                  nav
                  dense
                  style="max-height: 30rem; overflow-y: scroll"
                  @scroll.passive="handleScroll"

                >
                  <template v-if="isLoadingConversations">
                    <v-skeleton-loader
                      type="list-item-avatar-two-line"
                      class="mx-2 my-1"
                      v-for="n in 6"
                      :key="n"
                    />
                  </template>
                  <template v-if="filteredConversations.length > 0">
                    <v-list-item
                      v-for="(
                        conversation, index
                      ) in filteredConversations.filter(
                        (c) => c && c.sender_name !== 'Unknown'
                      )"
                      :key="index"
                      :active="
                        currentConversation?.conversation_id ===
                        conversation.conversation_id
                      "
                      @click="selectConversation(conversation)"
                      class="rounded-lg my-1"
                    >
                      <template #prepend>
                        <div class="position-relative mr-4">
                          <v-avatar size="40">
                            <v-img :src="conversation.sender_profile_picture" />
                          </v-avatar>
                          <div class="badge"></div>
                        </div>
                      </template>

                      <v-list-item-title class="font-weight-medium">
                        {{ conversation.sender_name }}
                      </v-list-item-title>
                      <v-list-item-subtitle
                        class="text-truncate"
                        style="max-width: 200px"
                      >
                        {{ conversation.last_message_text }}
                      </v-list-item-subtitle>
                    </v-list-item>
                  </template>
                  <template v-if="whatsappChats && whatsappChats.length > 0">
                    <v-list-item
                      v-for="(chat, index) in whatsappChats"
                      :key="index"
                      :active="selectedWhatsappChat === chat.id"
                      @click="selectWhatsAppChat(chat)"
                      class="rounded-lg my-1"
                    >
                      <template #prepend>
                        <div class="position-relative mr-4">
                          <v-avatar size="40">
                            <v-img :src="chat.profilePicUrl" />
                          </v-avatar>
                          <div class="badge"></div>
                        </div>
                      </template>

                      <v-list-item-title class="font-weight-medium">
                        {{ chat.name }}
                      </v-list-item-title>
                      <v-list-item-subtitle
                        class="text-truncate"
                        style="max-width: 200px"
                      >
                        {{ chat.lastMessage }}
                      </v-list-item-subtitle>
                    </v-list-item>
                  </template>

                  <v-skeleton-loader
                    v-if="isLoadingMore"
                    type="list-item-avatar-two-line"
                    class="mx-2 my-1"
                  />
                </v-list>
              </v-col>
              <!-- Chat Window -->
              <v-col cols="12" sm="8" class="d-flex flex-column chatwindow">
                <template v-if="currentConversation">
                  <v-toolbar
                    flat
                    height="70"
                    class="px-4"
                    style="
                      background-color: #fff;
                      border-bottom: 1px solid #eee;
                      border: none;
                      border-radius: 0 34px 0px 0px;
                      box-shadow: 0px 2px 20px 0px #6666661f;
                    "
                  >
                    <!-- Avatar + Status -->
                    <div class="mr-3 position-relative">
                      <img
                        width="48"
                        height="48"
                        style="border-radius: 50%"
                        :src="
                          currentConversation?.sender_profile_picture ||
                          currentConversation.profilePicUrl
                        "
                      />
                      <div class="badge"></div>
                    </div>

                    <!-- User Info -->
                    <div class="d-flex flex-column justify-center">
                      <div class="font-weight-medium text-body-1">
                        {{
                          currentConversation?.sender_name ||
                          currentConversation.name
                        }}
                      </div>
                      <div class="text-caption text-grey">Reply to message</div>
                    </div>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                  <v-divider />
                  <div
                    ref="messageContainer"
                    class="flex-grow-1 overflow-y-auto pa-4"
                    @scroll.passive="handleMessageScroll"
                  >
                    <div
                      v-for="(msg, index) in currentConversation?.messages ||
                      []"
                      :key="index"
                      class="mb-6"
                    >
                      <div
                        :class="
                          msg.direction === 'outbound'
                            ? 'd-flex justify-end'
                            : 'd-flex justify-start'
                        "
                      >
                        <div
                          class="d-inline-flex align-center"
                          style="max-width: 75%; position: relative"
                        >
                          <!-- إذا كانت صورة -->
                          <template
                            v-if="
                              msg?.type === 'image' ||
                              (msg?.type === 'file' &&
                                msg?.attachment?.mime_type?.includes(
                                  'image'
                                )) ||
                              msg?.type === 'image'
                            "
                          >
                            <!-- {{ msg?.attachment }} -->
                            <v-img
                              :src="msg?.attachment?.url || msg?.media_url"
                              width="200"
                              height="200"
                              class="rounded-lg cursor-pointer"
                              cover
                              @click="
                                openImageDialog(
                                  msg?.attachment?.url || msg?.media_url
                                )
                              "
                            />
                          </template>

                          <!-- إذا كان صوت -->
                          <template
                            v-if="
                              msg?.type === 'audio' ||
                              (msg?.type === 'file' &&
                                msg?.attachment?.mime_type?.includes(
                                  'audio'
                                )) ||
                              msg?.type === 'audio'
                            "
                          >
                            <audio controls :src="msg?.attachment?.url"></audio>
                          </template>
                          <!-- إذا كان فيديو -->
                          <template
                            v-if="
                              msg.type === 'video' ||
                              (msg?.type === 'file' &&
                                msg?.attachment?.mime_type?.includes(
                                  'video'
                                )) ||
                              msg?.type === 'video'
                            "
                          >
                            <video
                              controls
                              width="200"
                              height="200"
                              class="rounded-lg"
                              style="object-fit: cover"
                            >
                              <source
                                :src="msg?.attachment?.url"
                                type="video/mp4"
                              />
                              Your browser does not support the video element.
                            </video>
                          </template>

                          <!-- إذا كانت رسالة نصية -->
                          <template v-else>
                            <v-card
                              v-if="msg.type === 'text' || msg.type === 'chat'"
                              :color="
                                msg.direction === 'outbound'
                                  ? 'teal darken-2'
                                  : '#F2F2F2'
                              "
                              :text-color="
                                msg.direction === 'outbound' ? 'white' : 'black'
                              "
                              class="pa-3"
                              style="border-radius: 18px; font-size: 15px"
                              flat
                            >
                              {{ msg.text || msg.body }}
                            </v-card>
                          </template>
                        </div>
                      </div>
                      <div
                        :class="
                          msg.direction === 'outbound'
                            ? 'text-right mr-4'
                            : 'text-left ml-4'
                        "
                      >
                        <small class="text-grey">{{
                          formatTime(msg.sent_at)
                        }}</small>
                      </div>
                    </div>
                  </div>
                  <v-divider />
                  <div class="d-flex ga-10 pa-6">
                    <!-- Input Box -->
                    <div
                      class="d-flex item-center justify-space-between ga-2"
                      style="width: 95%"
                    >
                      <v-text-field
                        @keyup.enter="sendMessage"
                        v-model="newMessage"
                        placeholder="Type something here..."
                        hide-details
                        density="comfortable"
                        variant="outlined"
                        rounded
                        class="flex-grow-1"
                        style="background: white; border-radius: 12px"
                      >
                        <template #append-inner>
                          <!-- Emoji -->
                          <v-menu v-model="showEmojiPicker" offset-y>
                            <template #activator="{ props }">
                              <v-icon
                                v-bind="props"
                                size="25"
                                class="mx-1"
                                color="#666666"
                              >
                                mdi-emoticon-happy-outline
                              </v-icon>
                              <!-- Record -->
                              <v-btn
                                elevation="0"
                                variant="text"
                                :class="{ 'recording-animation': isRecording }"
                                @click="
                                  isRecording
                                    ? stopRecording()
                                    : startRecording()
                                "
                              >
                                <svg
                                  v-if="!isRecording"
                                  xmlns="http://www.w3.org/2000/svg"
                                  height="25px"
                                  viewBox="0 -960 960 960"
                                  width="25px"
                                  fill="#666666"
                                >
                                  <path
                                    d="M480-384q-50 0-85-35t-35-85v-240q0-50 35-85t85-35q50 0 85 35t35 85v240q0 50-35 85t-85 35Zm0-240Zm-36 480v-99q-98.8-13.1-163.4-87.05Q216-404 216-504h72q0 79.68 56.23 135.84 56.22 56.16 136 56.16Q560-312 616-368.16q56-56.16 56-135.84h72q0 100-64.6 173.95Q614.8-256.1 516-243v99h-72Zm36-312q20.4 0 34.2-13.8Q528-483.6 528-504v-240q0-20.4-13.8-34.2Q500.4-792 480-792q-20.4 0-34.2 13.8Q432-764.4 432-744v240q0 20.4 13.8 34.2Q459.6-456 480-456Z"
                                  />
                                </svg>
                                <svg
                                  v-else
                                  xmlns="http://www.w3.org/2000/svg"
                                  height="25px"
                                  viewBox="0 -960 960 960"
                                  width="25px"
                                  fill="#FF0000"
                                >
                                  <path
                                    d="M336-336h288v-288H336v288ZM480.28-96Q401-96 331-126t-122.5-82.5Q156-261 126-330.96t-30-149.5Q96-560 126-629.5q30-69.5 82.5-122T330.96-834q69.96-30 149.5-30t149.04 30q69.5 30 122 82.5T834-629.28q30 69.73 30 149Q864-401 834-331t-82.5 122.5Q699-156 629.28-126q-69.73 30-149 30Zm-.28-72q130 0 221-91t91-221q0-130-91-221t-221-91q-130 0-221 91t-91 221q0 130 91 221t221 91Zm0-312Z"
                                  />
                                </svg>
                              </v-btn>

                              <!-- Upload file -->
                              <v-icon
                                size="25"
                                class="mx-1"
                                color="#666666"
                                @click.stop="triggerFileSelect"
                              >
                                mdi-paperclip
                              </v-icon>
                            </template>
                            <v-card>
                              <div
                                v-if="showEmojiPicker"
                                class="emoji-picker-wrapper"
                              >
                                <emoji-picker
                                  @emoji-click="onEmojiClick"
                                ></emoji-picker>
                              </div>
                            </v-card>
                          </v-menu>
                        </template>
                      </v-text-field>
                      <div class="d-flex item-center align-center">
                        <input
                          ref="fileInput"
                          type="file"
                          accept="image/*,video/*,audio/*"
                          @change="handleFileChange"
                          style="display: none"
                        />

                        <!-- Preview Selected Image -->
                        <v-avatar v-if="selectedFile" size="28" class="mx-1">
                          <v-img :src="previewImage" alt="selected file" />
                        </v-avatar>
                        <v-skeleton-loader
                          v-if="avatarSkeleton"
                          type="avatar"
                        />
                      </div>
                    </div>
                    <!-- Send Button -->
                    <v-btn
                      :disabled="
                        !newMessage.trim() && !selectedFile && !avatarSkeleton
                      "
                      :style="{
                        cursor:
                          !newMessage.trim() && !selectedFile && !avatarSkeleton
                            ? 'not-allowed'
                            : 'pointer',
                      }"
                      color="teal lighten-2"
                      class="rounded-lg"
                      style="width: 48px; height: 48px"
                      @click="sendMessage"
                      @enter="sendMessage"
                    >
                      <v-icon color="white">mdi-send</v-icon>
                    </v-btn>
                  </div>
                </template>
                <template v-else>
                  <v-card
                    elevation="0"
                    class="pa-2 h-100 d-flex align-center justify-center flex-column"
                  >
                    <img
                      class="mb-4 d-block"
                      src="@/assets/images/empty-chat.svg"
                      alt="Empty Conversation"
                    />
                    <p
                      class="mb-2"
                      style="font-size: 20px; color: #237276; font-weight: 600"
                    >
                      No Conversation Selected
                    </p>
                    <p style="font-size: 16px; color: #1a1a1a">
                      Start a conversation by selecting a conversation from the
                      list above.
                    </p>
                  </v-card>
                </template>
                <v-dialog v-model="previewDialog" max-width="600px">
                  <v-card>
                    <v-img
                      :src="previewDialogImage"
                      aspect-ratio="1"
                      max-height="90vh"
                      class="rounded"
                      cover
                    />
                  </v-card>
                </v-dialog>
              </v-col>
            </v-row>
          </v-container>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import GlobalNav from "@/components/layout/GlobalNav.vue";
import SideBar from "@/components/layout/SideBar.vue";
import BreadCrumb from "@/components/layout/BreadCrumb.vue";
import apiClient from "@/core/buildRequest";
import SelectAccId from "@/views/MessageCenter/SelectAccId.vue";
import socket from "@/core/socketIo.js";
import "emoji-picker-element";
import MicRecorder from "mic-recorder-to-mp3";
import axios from "axios";
export default {
  components: {
    GlobalNav,
    SideBar,
    BreadCrumb,
    SelectAccId,
  },
  data() {
    return {
      recorder: new MicRecorder({ bitRate: 128 }),
      isRecording: false,
      audioUrl: null,
      linksData: [
        { name: "home", link: "/" },
        { name: "Messagescenter", link: "/messages-center" },
      ],
      conversations: [],
      currentPage: 1,
      newMessageSound: null,
      totalPages: 1,
      isLoadingMore: false,
      selectedPlatform: "all",
      selectedConversation: null,
      showFilterMenu: false,
      selectedFilterType: "all",
      messageContainer: null,
      searchQuery: "",
      hoverIndex: null,
      previewImage: null, // to hold base64 image preview
      selectedFile: null, // to hold the actual file object
      newMessage: "",
      showEmojiPicker: false,
      emojiList: [],
      selectedDmAccounts: null,
      isLoadingConversations: false,
      messagesPage: 1,
      hasMoreMessages: true,
      isLoadingMessages: false,
      previewDialog: false,
      previewDialogImage: null,
      sender_id: null,
      avatarSkeleton: false,
      whatsappChats: [],
      whatsappPage: 1,
      whatsappPerPage: 30,
      whatsappTotalPages: 1,
      whatsappHasMore: true,
      currentPlatform: "whatsapp", 
      selectedWhatsappChat: null,
      whats_app_number: null,
    };
  },
  computed: {
    filteredConversations() {
      let result = this.conversations;
      if (this.selectedPlatform !== "all") {
        result = result.filter(
          (convo) => convo.platform === this.selectedPlatform
        );
      }
      if (this.searchQuery.trim() !== "") {
        const query = this.searchQuery.trim().toLowerCase();
        result = result.filter((convo) => {
          const nameMatch =
            convo.sender_name?.toLowerCase()?.includes(query) || false;
          const textMatch =
            convo.last_message_text?.toLowerCase()?.includes(query) || false;
          return nameMatch || textMatch;
        });
      }
      if (this.selectedFilterType === "unread") {
        result = result.filter((convo) => convo.unread);
      } else if (this.selectedFilterType === "read") {
        result = result.filter((convo) => !convo.unread);
      }
      return result;
    },
    currentConversation() {
      return this.selectedConversation;
    },
    currentWhatsappChat() {
      return this.selectedWhatsappChat;
    },
  },
  methods: {
    formatTime(isoTime) {
      if (!isoTime || isNaN(new Date(isoTime))) return "";
      const date = new Date(isoTime);
      return date.toLocaleString("en-US", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
    },
    triggerFileSelect() {
      this.$refs.fileInput.click();
    },
    handleFileChange(event) {
      const file = event.target.files[0];
      if (!file) {
        console.error("❌ No file selected!");
        return;
      }
      const type = file.type;

      if (type.startsWith("image/")) {
        this.sendMediaMessage(file, "image");
      } else if (type.startsWith("video/")) {
        this.sendMediaMessage(file, "video");
      } else if (type.startsWith("audio/")) {
        this.sendMediaMessage(file, "audio");
      } else {
        console.error("❌ Unsupported file type:", type);
      }
      this.selectedFile = file;
      const reader = new FileReader();
      reader.onload = async (e) => {
        this.previewImage = e.target.result;
        // this.sendMessage();
      };
      reader.onerror = (error) => {
        console.error("❌ Error reading file:", error);
      };

      reader.readAsDataURL(file);
    },
    formatFileSize(size) {
      const kb = size / 1024;
      return `${kb.toFixed(2)} KB`;
    },
    startRecording() {
      this.recorder
        .start()
        .then(() => {
          this.isRecording = true;
          console.log("🔴 Recording started...");
        })
        .catch((e) => {
          console.error("❌ Failed to start recording", e);
        });
    },
    stopRecording() {
      this.recorder
        .stop()
        .getMp3()
        .then(([buffer, blob]) => {
          const file = new File(buffer, "voice.mp3", {
            type: blob.type,
            lastModified: Date.now(),
          });

          this.audioUrl = URL.createObjectURL(blob);

          const formData = new FormData();
          formData.append("media", file);

          apiClient
            .post("/dm/upload-media", formData)
            .then((response) => {
              console.log("✅ Media uploaded:", response.data);
              this.sendMediaMessage(file, "audio");
            })
            .catch((error) => {
              console.error("❌ Failed to upload media:", error);
            });

          console.log("✅ Recording ready:", file);
        })
        .catch((e) => {
          console.error("❌ Failed to get recording", e);
        })
        .finally(() => {
          this.isRecording = false;
        });
    },
    applyFilter(type) {
      this.selectedFilterType = type;
      this.showFilterMenu = false;
    },
    addEmoji(emoji) {
      this.newMessage += emoji;
      this.showEmojiPicker = false;
    },
    // getCurrentTime() {
    //   const now = new Date();
    //   const hours = String(now.getHours()).padStart(2, "0");
    //   const minutes = String(now.getMinutes()).padStart(2, "0");
    //   return `${hours}:${minutes}`;
    // },
    async fetchConversationMessages(conversationId) {
      try {
        const response = await apiClient.get(
          `/dm/conversations/${conversationId}/messages`,
          {
            params: {
              per_page: 100,
            },
          }
        );
        console.log("Fetched messages:", response.data.data[0].data);
        this.selectedConversation.messages =
          response.data.data[0].data.reverse(); // تأكد إن الـ backend بيرجع `data` مصفوفة
        this.scrollToBottom();
      } catch (error) {
        console.error("❌ Failed to fetch messages:", error);
      }
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const container = this.$refs.messageContainer;
        if (container) {
          container.scrollTop = container.scrollHeight;
        }
      });
    },
    selectConversation(convo) {
      console.log("Selected conversation:", convo);
      this.selectedConversation = convo;
      this.sender_id = convo.sender_id;
      this.selectedConversation.unread = false;
      this.scrollToBottom();
      this.fetchConversationMessages(convo.conversation_id);
    },
    selectPlatform(platform) {
      this.selectedPlatform = platform;
      const conversations = this.filteredConversations;
      if (conversations.length > 0) {
        this.selectedConversation = conversations[0];
      } else {
        this.selectedConversation = null;
      }
    },
    sendMediaMessage(file, type) {
      this.avatarSkeleton = true;
      if (!file || !["image", "video", "audio"].includes(type)) {
        console.error("❌ Invalid file or type");
        return;
      }
      const formData = new FormData();
      formData.append("media", file);
      apiClient
        .post("/dm/upload-media", formData)
        .then((res) => {
          const mediaUrl = res.data.url;
          const mimetype = file.type;
          const filename = file.name;

          const platform = this.selectedDmAccounts?.platform?.toLowerCase();

          // ✅ لو واتساب
          if (this.whatsappChats.length > 0) {
            socket.emit("send_message_whatsapp", {
              number: this.whats_app_number,
              media: {
                url: mediaUrl,
                mimetype: mimetype,
                filename: filename,
              },
            });

            this.currentConversation.messages.push({
              type,
              direction: "outbound",
              media_url: mediaUrl,
              sent_at: new Date().toISOString(),
            });

            this.previewImage = null;
            this.selectedFile = null;
            this.scrollToBottom();
            return;
          }

          // ✅ لو Facebook / Instagram
          const message = {
            page_id: this.selectedDmAccounts.page_id,
            recipient_id: this.sender_id,
            message: {
              type: type,
              content: mediaUrl,
            },
          };

          let eventName = "";
          if (platform === "messenger" || platform === "facebook") {
            eventName = "send_message_to_messenger";
          } else if (platform === "instagram") {
            eventName = "send_message_to_instagram";
          }

          socket.emit(eventName, message);

          this.currentConversation.messages.push({
            ...message,
            direction: "outbound",
            sent_at: new Date().toISOString(),
          });

          this.previewImage = null;
          this.selectedFile = null;
          this.scrollToBottom();
        })
        .catch((err) => {
          console.error("❌ Upload failed:", err);
        })
        .finally(() => {
          this.avatarSkeleton = false;
        });
    },
    sendMessage() {
      if (!this.newMessage.trim()) return;
      const platform = this.selectedDmAccounts?.platform?.toLowerCase();
      if (this.whatsappChats.length > 0) {
        if (!this.whats_app_number) {
          console.warn("❌ WhatsApp number not set");
          return;
        }
        socket.emit("send_message_whatsapp", {
          number: this.whats_app_number,
          message: this.newMessage,
        });
        this.currentConversation.messages.push({
          text: this.newMessage,
          direction: "outbound",
          type: "text",
          sent_at: new Date().toISOString(),
        });

        this.newMessage = "";
        this.scrollToBottom();
        return;
      }

      // ✅ باقي المنصات (Messenger/Instagram)
      if (!this.selectedDmAccounts) {
        console.warn("❌ No account selected for Meta platform");
        return;
      }

      const message = {
        page_id: this.selectedDmAccounts.page_id,
        recipient_id: this.sender_id,
        message: {
          content: this.newMessage,
          type: "text",
        },
      };

      let eventName = "";
      if (platform === "messenger" || platform === "facebook") {
        eventName = "send_message_to_messenger";
      } else if (platform === "instagram") {
        eventName = "send_message_to_instagram";
      } else {
        console.error("❌ Unsupported platform:", platform);
        return;
      }

      socket.emit(eventName, message);

      this.currentConversation.messages.push({
        ...message,
        direction: "outbound",
        sent_at: new Date().toISOString(),
      });

      this.newMessage = "";
      this.scrollToBottom();
    },
    async handleAccountSelected(account) {
      console.log("👀 Received account:", account);
      if (account.platform === "WhatsApp") {
        console.log("✅ Triggering WhatsApp");
        this.getWhatsAppChats();

        this.selectedConversation = null;
        this.conversations = [];
        this.whatsappChats = [];
      } else {
        console.log("✅ Triggering Meta");
        this.selectedDmAccounts = account;
        this.selectedConversation = null;
        this.conversations = [];
        this.whatsappChats = [];
        this.getConversations();
      }
    },
    getCurrentTime() {
      const now = new Date();
      return now
        .toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
        .toLowerCase();
    },
    handleScroll(event) {
  const target = event.target;
  const nearBottom =
    target.scrollHeight - target.scrollTop <= target.clientHeight + 50;

  if (!nearBottom || this.isLoadingMore) return;

  if (this.currentPlatform === "whatsapp") {
    if (this.whatsappPage <= this.whatsappTotalPages) {
      this.getWhatsAppChats(true);
    }
  } else if (this.currentPlatform === "meta") {
    if (this.currentPage < this.totalPages) {
      this.getConversations(this.currentPage + 1, true);
    }
  }
}
,
    async getConversations(page = 1, append = false) {
      if (this.isLoadingConversations || this.isLoadingMore) return;
      if (append) this.isLoadingMore = true;
      else this.isLoadingConversations = true;

      try {
        const time = new Date().getTime();
        await apiClient.post(`/dm/${this.selectedDmAccounts.account_id}/sync`);
        const response = await apiClient.get(
          `/dm/${this.selectedDmAccounts.id}/conversations?page=${page}`
        );

        const { data, pagination } = response.data.data;

        this.currentPage = pagination.current_page;
        this.totalPages = pagination.total_pages;

        if (append) {
          this.conversations = [...this.conversations, ...data];
        } else {
          this.conversations = data;
        }
      } catch (error) {
        console.error("❌ Error fetching conversations:", error);
      } finally {
        this.isLoadingConversations = false;
        this.isLoadingMore = false;
      }
    },
    openImageDialog(url) {
      this.previewDialogImage = url;
      this.previewDialog = true;
    },
    onEmojiClick(event) {
      const emoji = event.detail.unicode;
      this.newMessage += emoji;
      this.showEmojiPicker = false;
    },

    async getWhatsAppChats(loadMore = false) {
  if (this.isLoadingConversations) return;
  this.isLoadingConversations = true;
  this.isLoadingMore = loadMore;

  try {
    const res = await axios.get(`https://promxa.com:3030/whatsapp/chats`, {
      params: {
        page: this.whatsappPage,
        per_page: 30,
      },
    });

    const chats = res.data.data || [];

    await Promise.all(
      chats.map(async (chat) => {
        const wid = chat.id;
        try {
          const picRes = await axios.get(
            `https://promxa.com:3030/whatsapp/profile-pic/${wid}`
          );
          chat.profilePicUrl = picRes.data.profilePicUrl;
        } catch (picErr) {
          chat.profilePicUrl = null;
        }
      })
    );

    if (loadMore) {
      this.whatsappChats.push(...chats);
    } else {
      this.whatsappChats = chats;
    }

    const pagination = res.data.pagination;
    this.whatsappPage = pagination.current_page + 1;
    this.whatsappTotalPages = pagination.total_pages;

  } catch (err) {
    console.error("❌ Failed to load chats", err);
  } finally {
    this.isLoadingConversations = false;
    this.isLoadingMore = false;
  }
}
,
    async selectWhatsAppChat(chat) {
      const page = 1;
      const per_page = 1250;
      try {
        const response = await axios.get(
          `https://promxa.com:3030/whatsapp/messages/${chat.id}`,
          { params: { page, per_page } }
        );

        this.whats_app_number = chat.id.slice(0, -5);
        this.selectedWhatsappChat = chat.from;
        this.selectedConversation = {
          ...chat,
          messages: response.data.data || [],
          page,
          per_page,
          hasMore: (response.data.data || []).length === per_page,
        };

        // ✅ Scroll to bottom after messages are rendered
        this.$nextTick(() => {
          const container = this.$refs.messageContainer;
          if (container) {
            container.scrollTop = container.scrollHeight;
          }
        });

        const index = this.whatsappChats.findIndex((c) => c.id === chat.id);
        if (index !== -1) this.whatsappChats[index].unreadCount = 0;
      } catch (err) {
        console.error("❌ Failed to load WhatsApp messages:", err);
      }
    },
    async loadMoreWhatsAppMessages() {
      const convo = this.selectedConversation;
      if (!convo || !convo.hasMore) return;

      const nextPage = convo.page + 1;
      this.isLoadingMessages = true;

      try {
        const response = await axios.get(
          `https://promxa.com:3030/whatsapp/messages/${this.whats_app_number}@c.us`,
          { params: { page: nextPage, per_page: convo.per_page } }
        );

        const newMessages = response.data.data || [];

        // 🔁 احتفظ بموضع السكرول قبل ما تضيف الرسائل
        const container = this.$refs.messageContainer;
        const oldHeight = container.scrollHeight;

        // ✅ أضفهم في الأعلى
        convo.messages = [...newMessages, ...convo.messages];
        convo.page = nextPage;
        convo.hasMore = newMessages.length === convo.per_page;

        this.$nextTick(() => {
          const newHeight = container.scrollHeight;
          container.scrollTop = newHeight - oldHeight;
        });
      } catch (err) {
        console.error("❌ Failed to load older WhatsApp messages", err);
      } finally {
        this.isLoadingMessages = false;
      }
    },
    handleMessageScroll(e) {
      const container = e.target;
      if (container.scrollTop < 50 && !this.isLoadingMessages) {
        this.loadMoreWhatsAppMessages();
      }
    },
  },
  mounted() {
    this.newMessageSound = new Audio(
      require("@/assets/audio/new-notification-09-352705.mp3")
    );
    this.newMessageSound.volume = 0.6;
    socket.on("new_message", (data) => {
      console.log("📨 New message received:", data);
      const wid = data.from;
      const text = data.body || data.text || "[No Text]";
      let timestamp = null;

      if (data.timestamp && !isNaN(data.timestamp)) {
        try {
          timestamp = new Date(data.timestamp * 1000).toISOString();
        } catch (e) {
          console.warn("⏱️ Invalid timestamp:", data.timestamp);
          timestamp = new Date().toISOString();
        }
      } else {
        timestamp = new Date().toISOString();
      }
      // ✅ Play sound
      if (
        data.from !== "me" &&
        this.newMessageSound &&
        typeof this.newMessageSound.play === "function"
      ) {
        console.log("Playing sound", data.from);
        this.newMessageSound.play().catch((err) => {
          console.warn("🔇 Sound blocked by browser until user interacts", err);
        });
      }

      // ✅ WhatsApp handling
      if (wid && wid.includes("@c.us")) {
        let index = this.whatsappChats.findIndex(
          (c) => c.id === wid || c.wid === wid
        );

        const newMsg = {
          text,
          direction: "inbound",
          sent_at: timestamp,
          type: "text",
        };

        if (index !== -1) {
          const chat = this.whatsappChats[index];

          // ✅ Update last message and unread flag
          chat.lastMessage = text;
          chat.unread = true;
          chat.timestamp = data.timestamp;

          // ✅ Add to messages
          if (!Array.isArray(chat.messages)) {
            this.whatsappChats[index].messages = [];
          }
          this.whatsappChats[index].messages.push(newMsg);

          // ✅ Move chat to top
          const updated = this.whatsappChats.splice(index, 1)[0];
          this.whatsappChats.unshift(updated);

          // ✅ If this chat is currently open
          if (this.currentConversation?.id === wid) {
            if (!Array.isArray(this.currentConversation.messages)) {
              this.currentConversation.messages = [];
            }
            this.currentConversation.messages.push(newMsg);
            this.scrollToBottom();
          }
        } else {
          // ✅ New chat not in list
          const newChat = {
            id: wid,
            name: data.name || wid,
            profilePicUrl: data.profilePic || null,
            lastMessage: text,
            unread: true,
            timestamp: data.timestamp,
            messages: [newMsg],
          };
          this.whatsappChats.unshift(newChat);

          // ✅ Optional: open it automatically if no current selected
          // this.currentConversation = newChat;
        }

        return; // skip Meta
      }

      // ✅ Messenger / Instagram handling
      if (
        this.currentConversation &&
        this.currentConversation.conversation_id === data.conversation_id
      ) {
        if (!Array.isArray(this.currentConversation.messages)) {
          this.currentConversation.messages = [];
        }

        const alreadyExists = this.currentConversation.messages.some(
          (msg) =>
            msg.message_id === data.message_id &&
            msg.content === data.content &&
            msg.direction === data.direction
        );

        if (!alreadyExists) {
          this.currentConversation.messages.push(data);
          this.scrollToBottom();
        }
      }

      const index = this.conversations.findIndex(
        (c) => c.conversation_id === data.conversation_id
      );

      if (index !== -1) {
        this.conversations[index].last_message_text =
          data.text || "[Attachment]";
        this.conversations[index].unread = true;
        const updatedConvo = this.conversations.splice(index, 1)[0];
        this.conversations.unshift(updatedConvo);
      }
    });

    // socket.emit("send_message_whatsapp", {
    //   number: this.whats_app_number,
    //   message: "132465897",
    // });
    // socket.on("connect", () => {
    //   console.log("✅ whatsapp Socket connected");
    // });
  },
  beforeUnmount() {
    socket.off("new_message");
  },
};
</script>

<style scoped>
.flex-grow-1 {
  flex-grow: 1;
}

.h-100 {
  height: 100%;
}

.msgbox {
  width: 93%;
}

.chatwindow {
  height: 80vh;
}

.chatside {
  height: 80vh;
}
.recording-animation {
  animation: pulse 1s infinite;
  background-color: #ff5252 !important; /* أحمر للتسجيل */
  color: white !important;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(255, 82, 82, 0.7);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(255, 82, 82, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(255, 82, 82, 0);
  }
}
.search-conversation {
  display: flex;
  align-items: center;
  border: 1px solid #cccccc;
  border-radius: 8px;
  padding: 0 8px;
}

input {
  width: 100%;
  padding: 4px 2px;
  font-size: 14px;
  outline: none;
  box-shadow: none;
  transition: border-color 0.2s;
}
.badge {
  width: 10px;
  height: 10px;
  background-color: green;
  border-radius: 50%;
  position: absolute;
  top: 2px;
  left: 0;
  border: 2px solid #fff;
}
</style>
